module.exports = "/static/assets/998f2c842151641acf4fa126afb87de3.png";